module.exports = __webpack_public_path__ + "img/placeholder.4d000175.png";